// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-tooltip {
  max-width: 320px;
  animation: tooltip-fade-in 300ms ease-in;
}
.bolt-tooltip .bolt-callout-content {
  background-color: transparent;
}

.bolt-tooltip-content {
  background-color: rgba( 51, 51, 51 ,  0.95 );
  background-color: rgba( var(--palette-neutral-80,51, 51, 51) ,  0.95 );
  border-radius: 2px;
  color: rgba( 255, 255, 255 ,  1 );
  color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  padding: 8px 12px;
  text-align: left;
  word-break: break-word;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-tooltip-content {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-tooltip-content {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}

.bolt-tooltip-fade-out {
  animation: tooltip-fade-out 300ms ease-in;
}
.bolt-tooltip-fade-out.bolt-callout {
  pointer-events: none;
}

@keyframes tooltip-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes tooltip-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/*# sourceMappingURL=Tooltip.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TooltipEx/Tooltip.scss","webpack://./../azure-devops-ui/bin/Components/TooltipEx/Tooltip.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,wCAAA;ACAJ;ADEI;EACI,6BAAA;ACAR;;ADIA;EACI,4CEyKuB;EFxKvB,sEAAA;EACA,kBEoFI;EFnFJ,iCAAA;EACA,0DAAA;EAEA,iBAAA;ECFF,gBAAgB;ECuXV,sBAAA;ADrXR;AACA;EACE,wCAAwC;ECsXlC,gEAAA;EFrXA,sCEqIU;EFpIV,gEAAA;ACER;AACA;EDCA,wCAAA;EACI,gEAAA;ECCF,sCAAsC;EDCpC,gEAAA;ACCJ;;AAEA;EDEA,yCAAA;ACAA;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE;IDIF,UAAA;EACI;ECFF;IACE,UAAU;EDKV;ACHJ;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sCAAsC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
